import { action } from 'typesafe-actions';
import { CartActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const resetCart = (data): any => action(types.RESET_CART, data);
export const updateCart = (data): any => action(types.UPDATE_CART, data);

export default {
  resetCart,
  updateCart,
};
